module.exports = __webpack_public_path__ + "img/remittances.16b4b54e.svg";